import { ActionIcon, Anchor, Group } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"
import { Missing } from "@tfg/ui"

type Props = {
  value?: string
}

export const QRCodeCell = ({ value }: Props) =>
  value ? (
    <Anchor href={value} target="_blank" onClick={(e) => e.stopPropagation()}>
      <ActionIcon color="green" variant="transparent" size={50}>
        <Group wrap="nowrap" gap={0} align="flex-end">
          <IconExternalLink size={18} style={{ marginBottom: 1 }} />
        </Group>
      </ActionIcon>
    </Anchor>
  ) : (
    <Missing />
  )
